// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xq69J","content":"styles_content__xOe1j"};